export enum GoalsCategory {
  Professional = 'Professional',
  ProjectDepartment = 'Project/Department',
  Company = 'Company',
}
